/**
 * 事件流程说明：
 * 1. 编辑器内部触发 `editor_inner_message` 事件，并传递一个包含 `event` 和 `data` 的对象。
 * 2. 外部组件通过 `$note` 监听相应的 `event` 事件，获取到数据后进行业务处理。
 * 3. 如果 `event` 事件需要编辑器执行某些逻辑，在data中增加一个回调函数参数cb_insertNode
 * 4. 编辑器内部监听相应的 `event` 事件，并根据接收到的数据执行相应的逻辑。
 */

export default {
  /**
   * 编辑器内部触发的事件，用于通知外部组件有内部操作发生。
   * @param {string} type - 事件名称
   * @param {Object} data - 事件数据对象，包含目标值等信息
   */
  editor_inner_message: 'editor_inner_message',

  /**
   * 时间戳点击事件，用于通知外部组件用户点击了时间戳。
   */
  click_editor_time_stamp: 'click_editor_time_stamp',

  /**
   * 获取时间戳事件，用于请求编辑器提供时间戳信息。
   */
  get_editor_time_stamp_data: 'get_editor_time_stamp_data'
};
